/**
 * Indicates the height of the frontmost toast.
 * @type {number}
 */
export const frontmostHeight = '--toast-frontmost-height';
